// src/routes.jsx
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import VeilleRequest from './pages/VeilleRequest';
import Dashboard from './pages/Dashboard';
import EmailStats from './pages/EmailStats'; // Ajout de l'import pour la page de statistiques

// Composant ProtectedRoute pour sécuriser les pages
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/new-veille"
        element={
          <ProtectedRoute>
            <VeilleRequest />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/email-stats"
        element={
          <ProtectedRoute>
            <EmailStats />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;